import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import AppLayout from '../../layout/app.layout';
import PAGE_TITLE_LIST, { SEPERATOR } from '../../config/page-title.config';
import ListManageRecuringEvent from '../../components/content/list-manage-recurring-event.component';

const ManageRecuringEventView = () => {
  const { id } = useParams();
  const location = useLocation();

  const pageTitle = `${PAGE_TITLE_LIST.MANAGE_RECURRING_EVENTS}${
    location?.state?.name ? ` ${SEPERATOR} ${location.state.name}` : ''
  }`;

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListManageRecuringEvent id={id} />
    </AppLayout>
  );
};

export default ManageRecuringEventView;
